import UserGuard from '../../editor/guards/UserGuard';
import type { IRoute } from '@/shared/models/route.model';
import { lazy } from 'react';
const AuthenticatedStatisticsTemplateResolver = lazy(
  () => import('../templates/AuthenticatedStatisticsTemplateResolver')
);
const SharedStatisticsTemplateResolver = lazy(() => import('../templates/SharedStatisticsTemplateResolver'));

export const statisticsRoutes: IRoute[] = [
  {
    path: '/statistics/orders/:id',
    component: AuthenticatedStatisticsTemplateResolver,
    guard: UserGuard,
    children: [],
  },
  {
    path: '/statistics/orders/:id/shared/:token',
    component: SharedStatisticsTemplateResolver,
  },
];
